module.exports = __WEBPACK_EXTERNAL_MODULE__ux_form_element__;